<template>
  <div class="content">
    <div class="container-fluid h-100">
      <div class="container-fluid h-100">
        <div class="row h-100">
          <div class="col h-100">
            <card-item
              class="striped-tabled-with-hover"
              body-classes="table-full-width table-responsive"
            >
              <template slot="header">
                <div class="d-flex justify-content-between">
                  <div>
                    <h4 class="card-title">ABM Roles y Permisos</h4>
                    <p class="card-category">Roles</p>
                  </div>
                </div>
              </template>
              <div class="container-fluid h-100">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label for="quickFilter" class="label"
                        >Filtro rapido</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="quickFilter"
                        v-model="filtroRapido"
                      />
                    </div>
                  </div>
                </div>

                <div class="row" style="height: 100%">
                  <div class="col" style="position: relative; height: 100%">
                    <ag-grid-vue
                      style="width: 100%; height: 60vh"
                      class="ag-theme-alpine"
                      :gridOptions="gridOptions"
                      :columnDefs="columnsDefs"
                      :defaultColDef="defaultColDef"
                      :rowData="roles"
                      @grid-ready="onGridReady"
                      :getContextMenuItems="getContextMenuItems"
                    >
                    </ag-grid-vue>
                  </div>
                </div>
              </div>
            </card-item>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { get } from "lodash-es";

import { AgGridVue } from "ag-grid-vue";
import RolesTableActions from "./RolesTableActions.vue";
export default {
  name: "RolesList",
  components: {
    AgGridVue,
    // eslint-disable-next-line
    RolesTableActions,
  },
  beforeMount() {
    this.defaultColDef = {
      sortable: true,
      enableCellTextSelection: true,
      ensureDomOrder: true,
    };

    this.gridOptions = {
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agTotalRowCountComponent",
            align: "center",
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" },
        ],
      },
      enableClipboard: true,
      enableRangeSelection: true,
      suppressCopyRowsToClipboard: false,
    };
  },
  data: () => ({
    gridColumnApi: null,
    defaultColDef: null,
    filtroRapido: "",
    gridApi: null,
    roles: null,
    columnsDefs: [
      {
        field: "id_rol",
        flex: 1,
        headerName: "#",
        sort: "asc",
        comparator: (a, b) => {
          const numA = parseInt(a);
          const numB = parseInt(b);
          return numA - numB;
        },
      },
      { field: "nombre", flex: 2, headerName: "Nombre" },
      {
        cellRendererFramework: RolesTableActions,
        flex: 2,
        headerName: "Acciones",
      },
    ],
    gridOptions: {
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agTotalRowCountComponent",
            align: "center",
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" },
        ],
      },
      enableClipboard: true,
      enableRangeSelection: true,
      suppressCopyRowsToClipboard: false,
    },
  }),
  methods: {
    getContextMenuItems() {
      return ["copy", "excelExport"];
    },
    async getData() {
      this.gridApi.showLoadingOverlay();

      const resp = await axios.post("/execute", {
        method: "SEC.GetRoles",
        parameters: [],
      });
      if (resp.data.ok) {
        this.roles = get(resp, "data.result[0]", []);
        this.gridApi.hideOverlay();
      } else {
        this.$msgBoxOk(resp.data.message);
      }
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.gridApi.showLoadingOverlay();
      this.getData().then(() => {
        window.api = params.api;

        this.$nextTick(() => {
          this.gridApi.hideOverlay();
        });
      });
    },
    autoSizeAll(skipHeader) {
      let allColumnIds = [];
      this.gridColumnApi.getAllColumns().forEach(function (column) {
        allColumnIds.push(column.colId);
      });
      this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    },
  },
  watch: {
    filtroRapido(val) {
      this.gridApi.setQuickFilter(val);
    },
  },
};
</script>

<style scoped></style>
